import { FormattedMessage, useIntl } from "react-intl";
import { LocalizationMessages } from "../../localization/messages";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { SVGIcon2 } from "../common/SVGIconV2";
import { Theme } from "../../constants";
import { PageContextUtils } from "../../utils";

const { currentName = Theme.Default } = PageContextUtils.getThemeData();

export const RightSideDrawerError = props => {
  const { drawer, onClose, onRetry } = props;
  const { formatMessage } = useIntl();
  const { appID } = drawer;

  const headerTitle = useMemo(
    () =>
      formatMessage(
        LocalizationMessages.technicalProblemHeader(
          appID,
          currentName === Theme.MrGreen ? currentName : ""
        )
      ),
    [appID, formatMessage]
  );

  return (
    <div className="right-side-drawer-wrapper">
      <div className="right-side-drawer-header">
        <div
          className="close-right-side-drawer"
          onClick={() => onClose(drawer)}
        >
          <SVGIcon2 iconName="cool_arrow" />
        </div>
        <h2>{headerTitle}</h2>
      </div>
      <div className="right-side-drawer-error-body">
        <div className="right-side-drawer-flex-aligner">
          <i className="disconnect-icon"></i>
          <span className="error-title">
            <FormattedMessage {...LocalizationMessages.technicalProblemTitle} />
          </span>
          <p className="error-message">
            <FormattedMessage {...LocalizationMessages.technicalProblemBody} />
          </p>
          <button className="error-btn" onClick={() => onRetry(drawer)}>
            <FormattedMessage
              {...LocalizationMessages.technicalProblemButton}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

RightSideDrawerError.propTypes = {
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
  trackingInfo: PropTypes.shape({
    closeTracking: PropTypes.object,
    retryTracing: PropTypes.object
  }),
  drawer: PropTypes.object
};
